import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RelabelCaseService } from "src/services/relabelCases";
import { queryKeys } from "src/constants";

const useRouteCase = (relabelCaseService: RelabelCaseService, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync: routeCase, isPending: isRouting } = useMutation({
    mutationFn: (caseId: string) => relabelCaseService.routeCase(caseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.buildingPallets() });
      queryClient.invalidateQueries({ queryKey: queryKeys.palletLocations() });
      queryClient.invalidateQueries({ queryKey: queryKeys.palletStats() });
      queryClient.invalidateQueries({ queryKey: queryKeys.paginatedRelabelCases() });
      onSuccess?.();
    }
  });

  return { routeCase, isRouting };
};

export { useRouteCase };
